import { FaEdit } from "react-icons/fa";
import { TableListButton } from "../../../atoms/Button/TableListButton";

interface EditButtonProps {
  link: string;
}

export function EditButton({ link }: EditButtonProps) {
  return (
    <TableListButton color="white" link={link} bg="#2b88a1" icon={FaEdit} />
  );
}
